import { Component, For, createSignal, onCleanup } from 'solid-js';

export type ToastType = 'info' | 'success' | 'error';
export interface ToastItem { id: number; message: string; type: ToastType; }

const [toasts, setToasts] = createSignal<ToastItem[]>([]);
let idSeq = 1;

export function showToast(message: string, type: ToastType = 'info', timeout = 2500) {
  const id = idSeq++;
  setToasts((prev) => [...prev, { id, message, type }]);
  const timer = setTimeout(() => dismissToast(id), timeout);
  // Clean up timer if the toast is removed early
  onCleanup(() => clearTimeout(timer));
}

export function dismissToast(id: number) {
  setToasts((prev) => prev.filter((t) => t.id !== id));
}

export const Toaster: Component = () => {
  return (
    <div class="toaster" aria-live="polite" aria-atomic="true">
      <For each={toasts()}>{(t) => (
        <div class={`toast toast--${t.type}`} role="status">
          <span class="toast-icon" aria-hidden="true">
            {t.type === 'success' ? '✅' : t.type === 'error' ? '❌' : 'ℹ️'}
          </span>
          <span class="toast-message">{t.message}</span>
          <button class="toast-close" aria-label="Close" onClick={() => dismissToast(t.id)}>✕</button>
        </div>
      )}</For>
    </div>
  );
};
